<template lang="html">
	<div class="email">
		<HeadModule :openTarget="'native/current'"/>
		<div class="email_module">
			<h3 class="email_txt">重置密码</h3>
			<ul class="tab">
				<li @click="phone()"><span>手机找回</span></li>
				<li class="act"><span>邮箱找回</span></li>
			</ul>
			<div class="cellemail">
				<div class="cell_email">
					<input type="text" placeholder="请输入邮箱号" id="cell_email" v-model='email'>
				</div>
			</div>
			<div class="verification">
				<div class="verification_code">
					<input type="text" placeholder="验证码" id="verification_code" v-model='Everification'>
				</div>
				<div class="verification_btn" @click="getPhoneVerification()">
					{{content}}
				</div>
			</div>
			<div class="setPassword">
				<input type="password" placeholder="输入新密码（输入6-18位包含大小写及数字的密码）" id="setInput" class="setInput" v-model='setInput'>
				<img src="../assets/image/close.png" alt="" @click="setInputs()">
			</div>
			<div class="affirmPassword">
				<input type="password" placeholder="确认密码" id="affirmInput" class="affirmInput" v-model='affirmInput'>
				<img src="../assets/image/close.png" alt="" @click="affirmInputs()">
			</div>
			<div class="put_in" @click="eFind()">
				<p>立 即 找 回</p>
			</div>
		</div>

	</div>
</template>

<script>
	import utils from '@/utils/utils.js';
	import HeadModule from '@/components/HeadModule'

	export default {
		data() {
			return {
				email: '',
				Everification: '',
				content: '发送验证码',
				totalTime: 60,
				setInput: '',
				affirmInput: '',
				jumpTarget: '',
			}
		},
		components: {
			HeadModule: HeadModule,
		},
		mounted(){
			
		},
		methods: {
			setInputs() {
				let setInput = document.getElementById('setInput');
				if (setInput.type === "password") {
					setInput.type = "text"
				} else {
					setInput.type = "password"
				}
			},
			affirmInputs() {
				let affirmInput = document.getElementById('affirmInput');
				if (affirmInput.type === "password") {
					affirmInput.type = "text"
				} else {
					affirmInput.type = "password"
				}
			},
			phone() {
				this.$router.push({
					path: '/forgetPhone',
					query: {
						id: this.$route.query.id,
					}
				})
			},
			getPhoneVerification() {
				if (this.email == '') {
					utils.showMessage('邮箱输入错误')
				} else {
					this.$http({
						url: '/User/sendEmail',
						method: 'get',
						params: {
							email: this.email,
							type: 3,
							client: 'H5',
						},
					}).then((res) => {
						if (res.code == 0) {
							this.content = this.totalTime + 's后重新发送'
							let clock = window.setInterval(() => {
								this.totalTime--
								this.content = this.totalTime + 's后重新发送'
								if (this.totalTime < 0) {
									window.clearInterval(clock)
									this.content = '发送验证码'
									this.totalTime = 60
								}
							}, 1000)
						} else {
							utils.showMessage(res.msg);
						}
					})
				}

			},
			eFind() {
				if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email)) {
					if (this.Everification != '') {
						if (/^(?![^A-Za-z]+$)(?![^0-9]+$)[\x21-x7e]{6,18}$/.test(this.setInput)) {
							if (this.setInput == this.affirmInput) {
								this.$http({
									url: '/Registered/backPasswordToEmail',
									method: 'post',
									params: {
										email: this.email,
										sms_code: this.Everification,
										password: this.setInput,
									},
								}).then((res) => {
									if (res.code == '0') {
										this.$router.push({
											path: '/login',
											query: {
												id: this.$route.query.id,
											}
										})
									} else {
										utils.showMessage(res.msg)
									}
								})
							} else {
								utils.showMessage('两次密码不一致')
							}
						} else {
							utils.showMessage('密码输入有误')
						}
					} else {
						utils.showMessage('验证码输入有误')
					}
				} else {
					utils.showMessage('邮箱输入有误')
				}
			}
		}
	}
</script>

<style lang="css" scoped>
	.email_module {
		padding: 0 15px;
	}

	.email_txt {
		padding-left: 35px;
		padding-top: 35px;
		font-size: 24px;
		color: #1D2023;
	}

	.tab {
		display: flex;
		justify-content: center;
		font-size: 18px;
	}

	.tab li {
		padding: 45px 16px 40px 16px;
	}

	.tab .act span {
		padding: 5px 0;
		border-bottom: 2px solid #E60020;
	}

	.cellemail {
		height: 60px;
		margin: 0 25px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.cell_email {
		width: 100%;
	}

	#cell_email:disabled {
		background: #ffffff;
	}

	.cell_email input {
		width: 100%;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}

	.verification {
		height: 60px;
		margin: 0 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.verification_code input {
		width: 200px;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}

	.verification_btn {
		width: 85px;
		height: 25px;
		border: 1px solid #E50120;
		font-size: 12px;
		color: #E50120;
		text-align: center;
		line-height: 25px;
		border-radius: 5px;
	}

	.put_in {
		background: linear-gradient(#FE405A, #E50101);
		height: 45px;
		line-height: 45px;
		text-align: center;
		color: #ffffff;
		margin-top: 55px;
		border-radius: 40px;
		font-size: 20px;
	}

	/* 设置密码 */
	.setPassword {
		height: 60px;
		margin: 0 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.setPassword img {
		margin-left: 10px;
		width: 15px;
	}

	.setInput {
		width: 100%;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}

	.affirmPassword {
		height: 60px;
		margin: 0 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.affirmPassword img {
		margin-left: 10px;
		width: 15px;
	}

	.affirmInput {
		width: 100%;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}
</style>
